var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showPage == 1)?_c('router-view',{attrs:{"name":"m"}}):_vm._e(),(_vm.showPage == 2)?_c('router-view',{attrs:{"name":"pc"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }